// extracted by mini-css-extract-plugin
export default {"selectPaper":"styles_selectPaper__qhVqD"};